import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyPreferenceEntity } from './company-preference.entity';
import { PreferenceDetailEntity } from './preference-detail.entity';
import { PreferenceRbacRoleEntity } from './preference-rbac-role.entity';
import { PreferenceSetDefaultEntity } from './preference-set-default.entity';
import { PreferenceSetEntity } from './preference-set.entity';
import { PreferenceUserEntity } from './preference-user.entity';
import { TeamPreferenceEntity } from './team-preference.entity';

@Index('unique_type_name', ['name', 'type'], { unique: true })
@Entity('_preference')
export class PreferenceEntity extends BaseEntity {
	@Column('varchar', { name: '_name', nullable: true, length: 64 })
	public name!: string | null;

	@Column('varchar', { name: '_label', nullable: true, length: 255 })
	public label!: string | null;

	@Column('varchar', { name: '_type', nullable: true, length: 64 })
	public type!: string | null;

	@OneToMany(
		() => PreferenceRbacRoleEntity,
		(preferenceRbacRole) => preferenceRbacRole.fkPreference,
		{},
	)
	public preferenceRbacRoles!: Array<PreferenceRbacRoleEntity>;

	@OneToMany(
		() => PreferenceDetailEntity,
		(preferenceDetail) => preferenceDetail.fkPreference,
		{},
	)
	public preferenceDetails!: Array<PreferenceDetailEntity>;

	@OneToMany(
		() => PreferenceSetEntity,
		(preferenceSet) => preferenceSet.fkPreference,
		{},
	)
	public preferenceSets!: Array<PreferenceSetEntity>;

	@OneToMany(
		() => PreferenceSetDefaultEntity,
		(preferenceSetDefault) => preferenceSetDefault.fkPreference,
		{},
	)
	public preferenceSetDefaults!: Array<PreferenceSetDefaultEntity>;

	@OneToMany(
		() => PreferenceUserEntity,
		(preferenceUser) => preferenceUser.fkPreference,
		{},
	)
	public preferenceUsers!: Array<PreferenceUserEntity>;

	@OneToMany(
		() => CompanyPreferenceEntity,
		(companyPreference) => companyPreference.fkPreference,
		{},
	)
	public companyPreferences!: Array<CompanyPreferenceEntity>;

	@OneToMany(
		() => TeamPreferenceEntity,
		(teamPreference) => teamPreference.fkPreference,
		{},
	)
	public teamPreferences!: Array<TeamPreferenceEntity>;
}
